<template>
  <div>
    <div v-if="isStudyLoading">
      <div>
        <div class="centered-row" style="padding-top: 50px">
          <div class="loading">
            <Fai :icon="['far', 'circle-notch']" spin/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isStudyStable">
      <div v-if="shouldRenderMobileVersion">
        <div>
          <ResultsMobile></ResultsMobile>
        </div>
      </div>
      <div v-else>
        <div>
          <ResultsDesktop></ResultsDesktop>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    import {
        GET_IS_MOBILE_VIEWPORT, LOADING_COMPLETED_SUCCESS, LOADING_STARTED,
    } from '../services/constants'
    import {ResultsDesktopAsync} from './views/ResultsDesktopAsync'
    import ResultsMobile from "./views/ResultsMobile"

    export default {
        name: 'ResultsContainer',
        components: {
            ResultsMobile,
            'ResultsDesktop': ResultsDesktopAsync,
        },

        computed: {
            ...mapGetters([
                GET_IS_MOBILE_VIEWPORT,
            ]),
            shouldRenderMobileVersion() {
                return this[GET_IS_MOBILE_VIEWPORT]
            },
            isStudyLoading() {
                return this.studyResultsState.loadingState === LOADING_STARTED
                    || this.studyState.loadingState === LOADING_STARTED
            },
            studyResultsState() {
                return this.$store.state.studyResultsModule.studyResultsState
            },
            studyState() {
                return this.$store.state.dataModule.getStudyState
            },
            isStudyStable() {
                return this.studyResultsState.loadingState === LOADING_COMPLETED_SUCCESS
                    && this.studyState.loadingState === LOADING_COMPLETED_SUCCESS
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../scss/main";

  .loading {
    color: $red-2;
  }

</style>
